import { render, staticRenderFns } from "./CancelStart.vue?vue&type=template&id=085c85c2&"
import script from "./CancelStart.vue?vue&type=script&lang=js&"
export * from "./CancelStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports